/* @flow */

import type { $MediaQuery, $WorkbenchBreakpoints, $WorkbenchMediaQueries } from '../types/WorkbenchBreakpoints';
/**
 *
 * MQ1: ... -  BP1
 * MQ2: BP1 - BP2
 * MQ3: BP2 - BP3
 * MQ4: BP3 - BP4
 * MQ5: BP4 - BP5
 * MQ6: BP5 - ...
 *
 */

export const WorkbenchBreakpoints: $WorkbenchBreakpoints = {
  BP1: 479,
  BP2: 767,
  BP3: 1023,
  BP4: 1279,
  BP5: 1439
};

export default WorkbenchBreakpoints;

export const WorkbenchMediaQueries: $WorkbenchMediaQueries = {
  MQ1: 'MQ1',
  MQ2: 'MQ2',
  MQ3: 'MQ3',
  MQ4: 'MQ4',
  MQ5: 'MQ5',
  MQ6: 'MQ6'
};

export const getMediaQuery = (width: number): $MediaQuery => {
  switch (true) {

    case (width <= WorkbenchBreakpoints.BP1):
      return WorkbenchMediaQueries.MQ1;

    case (width > WorkbenchBreakpoints.BP1 && width <= WorkbenchBreakpoints.BP2):
      return WorkbenchMediaQueries.MQ2;

    case (width > WorkbenchBreakpoints.BP2 && width <= WorkbenchBreakpoints.BP3):
      return WorkbenchMediaQueries.MQ3;

    case (width > WorkbenchBreakpoints.BP3 && width <= WorkbenchBreakpoints.BP4):
      return WorkbenchMediaQueries.MQ4;

    case (width > WorkbenchBreakpoints.BP4 && width <= WorkbenchBreakpoints.BP5):
      return WorkbenchMediaQueries.MQ5;

    default:
      return WorkbenchMediaQueries.MQ6;
  }
};
